'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = academicUsers;
exports.download = download;
var DOWNLOAD = 'ms/academic-users/download';

var DOWNLOAD_SUCCESS = exports.DOWNLOAD_SUCCESS = 'ms/academic-users/download_success';
var DOWNLOAD_FAIL = 'ms/academic-users/download_fail';

function academicUsers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return state;
}

function download(packId) {
  return {
    types: [DOWNLOAD, DOWNLOAD_SUCCESS, DOWNLOAD_FAIL],
    meta: { packId: packId },
    promise: function promise(client) {
      return client.post('/v1/academic-downloads/pack/' + packId).then(function (_ref) {
        var url = _ref.url;

        window.location = url;
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/academicUsers.js
// module id = 576
// module chunks = 0